import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Card from "../Components/Card";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { configurationConstants } from "../store/actions/types";
import { makeSessionRequest } from "../utils/makeSessionRequest";
import useUserConfiguration from "../utils/updateUserConfiguration";
export default function PrimaryBar({ secondaryBarHidden, blinkSecondaryBar, setSecondaryBarHidden, }) {
    const dispatch = useAppDispatch();
    const { primaryBarSelection } = useAppSelector((state) => state.configuration);
    const configData = useAppSelector((state) => state.configData.current);
    const { getSelectedOption } = useUserConfiguration();
    const handleClick = (item) => {
        if (!secondaryBarHidden && item.name === primaryBarSelection.name) {
            blinkSecondaryBar();
            return;
        }
        if (secondaryBarHidden) {
            setSecondaryBarHidden(false);
            dispatch({
                type: configurationConstants.SET_PRIMARY_BAR_SELECTION,
                payload: item,
            });
            return;
        }
        setSecondaryBarHidden(true);
        setTimeout(() => {
            setSecondaryBarHidden(false);
            dispatch({
                type: configurationConstants.SET_PRIMARY_BAR_SELECTION,
                payload: item,
            });
        }, 500);
    };
    const hasSubFeatures = (features) => {
        var _a;
        return ((_a = features[0]) === null || _a === void 0 ? void 0 : _a.options) ? true : false;
    };
    function lastName(s) {
        return s
            .split(" ")
            .map((word) => {
            if (word === "FramE")
                return "Frame";
            // Replace all occurrences of "PrelaM" within the word.
            return word.replace(/PrelaM/g, "Prelam");
        })
            .join(" ");
    }
    const getLabel = (feature) => {
        const label = hasSubFeatures(feature.options || [])
            ? feature.options
                .map((subFeature) => getSelectedOption(feature.name, subFeature.name))
                .map((option) => option.map((option) => option.name).join(","))
                .filter((option) => option)
                .join(" ")
            : getSelectedOption(feature.name, "")
                .map((option) => option.name)
                .join(",");
        return label || "---";
    };
    return (_jsx("div", Object.assign({ style: { borderColor: "#DCDCDC", backgroundColor: "#f5f5f5" }, className: "z-10 absolute bottom-0 overflow-y-auto  p-4 pb-2 flex flex-row w-full border-t border-r-2" }, { children: configData.map((item, idx) => (_jsx("div", Object.assign({ className: "mr-4" }, { children: _jsx(Card, { disabled: false, selected: (primaryBarSelection === null || primaryBarSelection === void 0 ? void 0 : primaryBarSelection.name) === item.name && !secondaryBarHidden, name: item.name, onClick: () => {
                    makeSessionRequest("selected_card", {
                        cardName: item.name,
                    });
                    handleClick(item);
                }, label: lastName(getLabel(item)) }, idx) }), item.name))) })));
}
